import UDExListItemBase from "../ListItemBase.js";

const cleanLabel = (str: string) : string => {
  return str.replace(/<\/?b[^>]*>/g, "");
};

const stringLabelStartsWithLetterKey = (label: string, letterKey:string): boolean => {
  return cleanLabel(label).toLowerCase().startsWith(letterKey);
};

const listBaseItemStartsWithLetterKey = (item: Element, letterKey: string): boolean => {
  return stringLabelStartsWithLetterKey((item as UDExListItemBase)._state?.label as string || "", letterKey);
};

const popOverItemLabelStartsWithLetterKey = (item: Element, letterKey: string): boolean => {
  return stringLabelStartsWithLetterKey((item as UDExListItemBase)?.innerText || "", letterKey);
};

const itemLabelStartsWithLetterKey = (item: Element, letterKey: string): boolean => {
  return listBaseItemStartsWithLetterKey(item as UDExListItemBase, letterKey) || popOverItemLabelStartsWithLetterKey(item, letterKey);
};

const itemCanBeFocused = (item: Element, letterKey: string): boolean => {
  const itemDisabled = (item as UDExListItemBase)?.disabled || false;
  return !itemDisabled && itemLabelStartsWithLetterKey(item, letterKey);
};

// finds first label in list items starting with letterKey
const findFirstItemLabelStartsWithLetterKey = (letterKey: string, items: Element[]) => {
  const findIndex = items.findIndex(item => itemCanBeFocused(item, letterKey));
  return findIndex > -1 ? findIndex : 0;
};

const findNextItemLabelStartsWithKey = (key: string, items: Element[], start: number): number => {
  return items.slice(start, items.length).findIndex(item => itemCanBeFocused(item, key));
};

// find number of item starting with letterKey
const getSearchedKeyItemsCount = (letterKey: string, items: Element[]): number => {
  const searchedItemsCountArray = items.map(i => {
    return itemLabelStartsWithLetterKey(i, letterKey) ? i : null;
  }).filter(i => i) as Element[];
  return searchedItemsCountArray.length;
};

export {
  cleanLabel, stringLabelStartsWithLetterKey,
  itemLabelStartsWithLetterKey, findFirstItemLabelStartsWithLetterKey,
  getSearchedKeyItemsCount, findNextItemLabelStartsWithKey,
};
